const rooster = {
  threads: {
    borderLeft: '1px solid #cccccc',
    position: 'relative',
    width: '298px',
    height: '100%',
    float: 'left',
  },
  tabs: {
    position: 'relative',
    width: '100%',
    borderBottom: '1px solid #ccc',
  },
  tab: {
    backgroundColor: 'white',
    color: 'black',
    border: '1px solid white',
  },
  swipableThreads: {
    position: 'relative',
    overflow: 'hidden',
  },
  underline: {
    height: '4px',
    marginTop: '-4px',
    backgroundColor: '#90CAF9',
  },
  emails: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
  editorColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flex: '1.5',
  },
  helpColumn: {
    flex: '1',
  },
  texts: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
}

const tops = {
  threads: {
    borderLeft: '1px solid grey',
    position: 'relative',
    width: '300px',
    height: '100%',
    float: 'left',
    backgroundColor: 'white',
  },
  tabsContainer: {
    backgroundColor: 'transparent',
  },
  tabs: {
    position: 'relative',
    width: '100%',
    borderBottom: '1px solid grey',
  },
  tab: {
    color: 'black',
    backgroundColor: 'white',
  },
  swipableThreads: {
    position: 'relative',
    overflow: 'hidden',
  },
  underline: {
    height: '4px',
    marginTop: '-4px',
    backgroundColor: '#90CAF9',
  },
  emails: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
  editorColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flex: '1.5',
  },
  helpColumn: {
    flex: '1',
  },
  texts: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
}

module.exports = process.env.REACT_APP_IS_TOPS ?
  tops :
  rooster



// WEBPACK FOOTER //
// ./src/components/Settings/PostApptReviewMessageEditor/TabStyles.js